<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ENQUIRY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Enquiry</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<!-- CONTACT FORM
================================================== -->
<section class="bg-very-light-gray py-md-8 pb-lg-0">
    <div class="container">
        <div class="row align-items-end">
            <div class="col-lg-6 d-none d-lg-block mb-5">
                <img src="assets/img/enquiry-image.jpg" class="mt-0 pt-0 align-self-start" alt="enquiry">
            </div>
            <div class="col-lg-6 py-lg-5">
                <div class="faq-form">
                    <!--                    <img src="assets/img/hostel/AUCETArtboard.png" class="w-30 h-30 p-0 m-0"/>-->
                    <h2 class="mb-4 text-primary">Online Application</h2>
                    <form [formGroup]="addEnquiryForm" class="contact quform"
                          action="https://elearn.websitelayout.net/quform/contact.php"
                          method="post" enctype="multipart/form-data" onclick="">
                        <div class="quform-elements">
                            <div class="row">
                                <!-- Begin Text input element -->
                                <div class="col-md-6">
                                    <div class="quform-element form-group">
                                        <label for="name">Your Name <span class="quform-required">*</span></label>
                                        <div class="quform-input">
                                            <input class="form-control" id="name" type="text" formControlName="name"
                                                   placeholder="Enter your name here"/>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Text input element -->

                                <!-- Begin Text input element -->
                                <div class="col-md-6">
                                    <div class="quform-element form-group">
                                        <label for="email">Your Email <span class="quform-required">*</span></label>
                                        <div class="quform-input">
                                            <input class="form-control" id="email" type="text" formControlName="email"
                                                   placeholder="Your email here"/>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Text input element -->

                                <!-- Begin Text input element -->
                                <div class="col-md-6">
                                    <div class="quform-element form-group">
                                        <label>Phone <span class="quform-required">*</span></label>
                                        <div class="quform-input">
                                            <input class="form-control" id="" type="number" formControlName="contact"
                                                   placeholder="Your Phone number"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="quform-element form-group">
                                        <label>Alternate Phone <span class="quform-required">*</span></label>
                                        <div class="quform-input">
                                            <input class="form-control" type="number"
                                                   formControlName="alternate_contact"
                                                   placeholder="Alternate Phone number"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="quform-element form-group">
                                        <label>City<span class="quform-required">*</span></label>
                                        <div class="quform-input">
                                            <input class="form-control" type="text" formControlName="city"
                                                   placeholder="Your City"/>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Text input element -->

                                <!-- Begin Text input element -->
                                <div class="col-md-6">
                                    <div class="quform-element form-group">
                                        <label for="phone">State</label>
                                        <div class="quform-input">
                                            <input class="form-control" id="phone" type="text" formControlName="state"
                                                   placeholder="Your State"/>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Text input element -->

                                <!-- Begin Text input element -->
                                <div class="col-md-6">
                                    <div class="quform-element form-group">
                                        <label>Course Type <span class="quform-required">*</span></label>
                                        <div class="quform-input">
                                            <select class="form-control" formControlName="course_type">
                                                <option value="">Select Course Type</option>
                                                <option value="Post Graduate">Post Graduate</option>
                                                <option value="Under Graduate">Under Graduate</option>
                                                <option value="Diploma">Diploma</option>
                                                <option value="Doctorate">Doctorate</option>
                                                <option value="Integrated UG & PG">Integrated UG &amp; PG</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Text input element -->

                                <!-- Begin Text input element -->
                                <div class="col-md-6">
                                    <div class="quform-element form-group">
                                        <label for="phone">Course</label>
                                        <div class="quform-input">
                                            <select class="form-control" formControlName="course">
                                                <option value="">Select Course</option>
                                                <option value="M.Tech(CS)">M.Tech(CS)</option>
                                                <option value="M.Tech(Civil)">M.Tech(Civil)</option>
                                                <option value="M.Tech(ME)">M.Tech(ME)</option>
                                                <option value="M.com">M.com</option>
                                                <option value="MA(Eng)">MA(Eng)</option>
                                                <option value="MA (Economics)">MA (Economics)</option>
                                                <option value="MA (Journalism & Mass Communication)">MA (Journalism
                                                    &amp; Mass Communication)
                                                </option>
                                                <option value="Msc (Math)">Msc (Math)</option>
                                                <option value="Msc(Physics)">Msc(Physics)</option>
                                                <option value="Msc(Chemistry)">Msc(Chemistry)</option>
                                                <option value="Msc(Botany)">Msc(Botany)</option>
                                                <option value="Msc(Zoology)">Msc(Zoology)</option>
                                                <option value="MBA">MBA</option>
                                                <option value="MCA">MCA</option>
                                                <option value="M.Lib">M.Lib</option>
                                                <option value="LLM">LLM</option>
                                                <option value="MBA (Retail Management)">MBA (Retail Management)</option>
                                                <option value="Risk Reduction and Management">Risk Reduction and
                                                    Management
                                                </option>
                                                <option value="MBA (Hospital Management)">MBA (Hospital Management)
                                                </option>
                                                <option value="MBA (Pharmaceutical Management)">MBA (Pharmaceutical
                                                    Management)
                                                </option>
                                                <option value="M.Sc (Physiotherapy)">M.Sc (Physiotherapy)</option>
                                                <option value="Master of Optometry">Master of Optometry</option>
                                                <option value="MA (Geography)">MA (Geography)</option>
                                                <option value="MA (Hindi)">MA (Hindi)</option>
                                                <option value="MA (History)">MA (History)</option>
                                                <option value="MA (Philosophy)">MA (Philosophy)</option>
                                                <option value="MA (Psychology)">MA (Psychology)</option>
                                                <option value="MA (Public Administration)">MA (Public Administration)
                                                </option>
                                                <option value="MA (Sociology)">MA (Sociology)</option>
                                                <option value="M.Des (Fashion Design)">M.Des (Fashion Design)</option>
                                                <option value="Master in Interior Designing">Master in Interior
                                                    Designing
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Text input element -->

                                <!-- Begin Textarea element -->
                                <div class="col-md-12">
                                    <div class="quform-element form-group">
                                        <label for="message">Message <span class="quform-required">*</span></label>
                                        <div class="quform-input">
                                            <textarea class="form-control" id="message" formControlName="message"
                                                      rows="3"
                                                      placeholder="Tell us a few words"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Textarea element -->

                                <!-- Begin Submit button -->
                                <div class="col-md-12">
                                    <div class="quform-submit-inner">
                                        <button class="butn secondary" type="submit" (click)="submit()"><i
                                            class="far fa-paper-plane icon-arrow before"></i><span class="label">Send Message</span><i
                                            class="far fa-paper-plane icon-arrow after"></i></button>
                                    </div>
                                    <div class="quform-loading-wrap text-start"><span class="quform-loading"></span>
                                    </div>
                                </div>
                                <!-- End Submit button -->

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
